export type AddressCardLayout = {
  showAddressHeader: boolean;
};

export function getAddressCardLayout(addressLineCount: number, hasNote = false): AddressCardLayout {
  const lines = Math.min(Math.max(addressLineCount, 1), 4);

  return {
    showAddressHeader: hasNote ? lines <= 1 : lines <= 2,
  };
}

export function measureTextLineCount(el: HTMLElement, text: string): number {
  const styles = getComputedStyle(el);
  const lineHeight = Number.parseFloat(styles.lineHeight);

  if (!text || !Number.isFinite(lineHeight) || lineHeight <= 0) {
    return text ? 1 : 0;
  }

  const mirror = Object.assign(document.createElement('div'), { textContent: text });
  mirror.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:${el.clientWidth}px;font:${styles.font};line-height:${styles.lineHeight};letter-spacing:${styles.letterSpacing};white-space:pre-wrap;overflow-wrap:anywhere;word-break:break-word`;

  document.body.appendChild(mirror);
  const lines = Math.max(1, Math.ceil(mirror.scrollHeight / lineHeight));
  mirror.remove();

  return lines;
}
